<template>
  <div class="l-recorder-container">
    <!-- 置灰：disabled   默认：default   录音中：recording -->
    <div
      ref="barparent"
      class="btn-recorder"
      @click="handleRecordBtnClick"
      :class="{
        disabled: status === RecordBtnStatus.DISABLE || disabled,
        default: status === RecordBtnStatus.INITIAL,
        recording: status === RecordBtnStatus.RECORDING,
      }"
    >
      <span class="text">{{ buttonText }}</span>
      <!-- 进度条 -->
      <ProcessWeb
        v-if="status === RecordBtnStatus.RECORDING"
        :total-time="options.duration"
        :current-time="currentTime"
      />
      <!-- 录音小喇叭 -->
      <Micphone v-if="status === RecordBtnStatus.RECORDING" :wave="this.wave" />
    </div>
  </div>
</template>

<script>
import ProcessWeb from "./src/components/process-web"
import Micphone from "./src/components/micphone"
import Recorder from "./src/tool/recorder"
import { RecordBtnStatus, RecordTimeMin } from './src/tool/const'
import { resetScore, getMode } from './src/tool/util'

export default {
  components: { ProcessWeb, Micphone },
  props: {
    /**
     * 参数 options：
     *  elementType  元素类型（例如：821）
     *  duration     最长录音时长
     *  keywords     中心词
     *  text         标准答案文本
     *  audioFileName     音频文件命名
     */
    options: {
      type: Object,
      default: function () {
        return null
      },
    },
    /**
     * 是否可点击
     */
    disabled: {
      type: Boolean,
      default: false,
    },
    /**
     * 允许手动停止录音 默认false
     */
    allowManual: {
      type: Boolean,
      default: false,
    },
    btnText: [String],
    /**
     *
     * event
     *  @start
     *  @stop
     *  @result
     *
     * function
     *  checkPermission
     */
  },
  data() {
    return {
      RecordBtnStatus,
      mode: "",
      status: RecordBtnStatus.INITIAL, // 0：不能开始录音  1：可以点击录音  2：录音中可以结束录音
      //  ['点击按钮回答问题', '点击提交录音', '录音中'],
      btnDefaultTxt: "点击按钮回答问题",
      wave: 0, // 当前波形最高点
      currentTime: 0, // 当前时间点
      isMicphoneAuthorization: false,
      isRecordBtnLoading: false, // 录音按钮是否可点击
    }
  },
  computed: {
    buttonText() {
      return [
        this.btnText || this.btnDefaultTxt,
        this.btnText || this.btnDefaultTxt,
        "录音中...",
        "录音完成",
      ][this.status]
    },
  },
  destroyed() {
    this.destroyRecorder()
  },
  methods: {
    handleRecordBtnClick() {
      if (this.isRecordBtnLoading) return
      this.isRecordBtnLoading = true

      // 已经录音，且不允许手动停止
      if (this.isMicphoneAuthorization && !this.allowManual && this.recorder) {
        // 正在录音
        return
      }

      // 手动停止
      if (this.isMicphoneAuthorization && this.allowManual && this.recorder) {
        this.stopRecording()
        return
      }

      this.destroyRecorder()
      this.startRecording()
    },
    destroyRecorder() {
      this.recorder && this.recorder.stop()
      this.recorder = null
    },
    startRecording() {
      this.mode = getMode(this.options.elementType)
      this.recorder = new Recorder({
        mode: this.mode,
        text: this.options.text,
        audioFileName: this.options.audioFileName,
      })

      // 录音初始化成功的回调
      this.recorder.oninit = this.recorderInit

      // 实时处理录音数据
      this.recorder.onprocess = this.recorderProcess

      // 停止录音并返回结果
      this.recorder.onstop = this.recorderStop

      this.recorder.onerror = this.recorderError

      // 点击获取授权
      this.getPermission()
    },
    recorderInit() {
        // 初始化完成
        this.isRecordBtnLoading = false
        this.$emit("init")
    },
    recorderProcess(data) {
      this.wave = data.wave
      this.currentTime = data.duration
      // 时间到自动停止

      if (
        this.status === RecordBtnStatus.RECORDING &&
        this.recorder.status === this.recorder.STATUS_TYPE.RECORDING &&
        data.duration >= this.options.duration
      ) {
        this.recorder.stop()
        this._setStop()
      }
    },
    recorderStop(data) {
      data.suggestedScore = resetScore(this.options.keywords, this.mode, data)
      this.$emit("result", data)
      this.reset()
    },
    recorderError(err) {
      this.isRecordBtnLoading = false
      if (err) this.reset()
    },

    stopRecording() {
      // 录音不能小于3秒
      if (this.currentTime < RecordTimeMin) {
        this.$lToast("当前录音时间太短请继续录音～")
        this.isRecordBtnLoading = false
        return
      }
      this.recorder.stop()
      this._setStop()
    },

    getPermission() {
      Recorder.permission()
        .then(() => {
          this.recorder.init()
          this.isMicphoneAuthorization = true
        })
        .catch((err) => {
          this.isRecordBtnLoading = false
          this.$lPrompt({
            message: `麦克风授权失败:请检查麦克风授权。${err}`,
            successFn: () => {},
          })
        })
    },

    start() {
      this.recorder.start()
      this._setStart()
    },
    reset() {
      this.currentTime = 0
      this.status = RecordBtnStatus.INITIAL
      this.wave = 0
      this.recorder = null
    },
    _setStart() {
      this.status = RecordBtnStatus.RECORDING
      this.$emit("start")
    },
    _setStop() {
      this.status = RecordBtnStatus.DISABLE
      this.isRecordBtnLoading = false
    },
  },
}
</script>

<style lang="stylus">
@import './index.styl'
</style>
